module.exports = __webpack_public_path__ + "static/media/building--gray.3229d0c9.svg";